
export default {
  state: {
    token: ''
  },
  getters: {

  },
  actions: {
    login ({ commit }, token = '') {
      commit('SET_TOKEN', token)
      localStorage.setItem('token_key', token)
    },
    logout ({ commit }) {
      commit('SET_TOKEN', '')
      localStorage.setItem('token_key', '')
    }
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    }
  }
}
